// import React, {useEffect, useRef, useState} from 'react';
// import * as THREE from 'three';
// import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
// import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
//
// const ThreeDModels = () => {
//     const mountRef = useRef(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [modelInfo, setModelInfo] = useState("");
//
//     useEffect(() => {
//         // Set up scene, camera, and renderer
//         const width = mountRef.current.clientWidth;
//         const height = mountRef.current.clientHeight;
//
//
//         const scene = new THREE.Scene();
//         scene.background = new THREE.Color(0x333333); // Dark background
//
//         const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
//         camera.position.set(0, 2, 5);
//
//         const renderer = new THREE.WebGLRenderer({antialias: true});
//         renderer.setSize(width, height);
//         renderer.outputColorSpace = THREE.SRGBColorSpace;
//         mountRef.current.appendChild(renderer.domElement);
//
//         // Add orbit controls
//         const controls = new OrbitControls(camera, renderer.domElement);
//         controls.enableDamping = true;
//         controls.dampingFactor = 0.25;
//
//         // Add lighting
//         const ambientLight = new THREE.AmbientLight(0xffffff, 1.0);
//         scene.add(ambientLight);
//
//         const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5);
//         directionalLight.position.set(5, 10, 7);
//         scene.add(directionalLight);
//
//         // Add grid helper for reference
//         const gridHelper = new THREE.GridHelper(10, 10);
//         scene.add(gridHelper);
//
//         // Debug function to print object hierarchy
//         const debugObject = (obj, indent = 0) => {
//             const spaces = ' '.repeat(indent);
//             let info = `${spaces}${obj.type}: ${obj.name || 'unnamed'}\n`;
//             if (obj.children && obj.children.length > 0) {
//                 obj.children.forEach(child => {
//                     info += debugObject(child, indent + 2);
//                 });
//             }
//             return info;
//         };
//
//         // Load the model
//         const loader = new GLTFLoader();
//         console.log('Attempting to load model...');
//
//         loader.load(
//             '/models/test1.glb',
//             (gltf) => {
//                 console.log('Model loaded successfully!');
//                 const model = gltf.scene;
//
//                 // Debug model structure
//                 const modelStructure = debugObject(model);
//                 console.log("Full model structure:");
//                 // console.log(modelStructure);
//                 setModelInfo(modelStructure);
//
//                 // Count meshes and lines
//                 let meshCount = 0;
//                 let lineCount = 0;
//                 model.traverse((node) => {
//                     if (node.isMesh) {
//                         meshCount++;
//                     }
//                     if (node.isLineSegments) {
//                         lineCount++;
//                         console.log(`Found LineSegments: ${node.name}`);
//                         // Enhance wireframe visibility
//                         if (node.material) {
//                             node.material = new THREE.LineBasicMaterial({
//                                 color: 0x00ffff, // Bright cyan color
//                                 linewidth: 2
//                             });
//                         }
//                     }
//                 });
//                 console.log(`Model contains ${meshCount} meshes and ${lineCount} line segments.`);
//
//                 const cabinet = model.getObjectByName('DWG_72IMOSXD01_IM_DOOR_NORM'); // Replace 'Cabinet' with the actual name
//                 // console.log(cabinet)
//                 const geo = model.getObjectByName('Geometry')
//                 let bbox = new THREE.BoxHelper(geo, 0xffff00);
//                 console.log(bbox)
//
//                 // Apply texture to a specific layer/object
//                 const doorObject = model.getObjectByName('DWG_72IMOSXD01_IM_DOOR_NORM');
//                 if (doorObject) {
//                     // Load the wood texture
//                     const textureLoader = new THREE.TextureLoader();
//                     const woodTexture = textureLoader.load('/textures/wood.jpg');
//
//                     // Traverse doorObject and update each mesh material
//                     doorObject.traverse((child) => {
//                         if (child.isMesh) {
//                             // Option 1: Replace the material completely with a textured material
//                             child.material = new THREE.MeshStandardMaterial({
//                                 map: woodTexture,
//                                 metalness: 0.2,
//                                 roughness: 0.8
//                             });
//                             // Option 2: Alternatively, you could modify the existing material:
//                             // child.material.map = woodTexture;
//                             // child.material.needsUpdate = true;
//                         }
//                     });
//                     console.log("Applied wood texture to DWG_72IMOSXD01_IM_DOOR_NORM");
//                 } else {
//                     console.warn("Object with name 'DWG_72IMOSXD01_IM_DOOR_NORM' not found.");
//                 }
//
//                 // Center and scale model
//                 const box = new THREE.Box3().setFromObject(model);
//                 const center = box.getCenter(new THREE.Vector3());
//                 const size = box.getSize(new THREE.Vector3());
//
//
//                 if (size.length() > 0) {
//                     // Center model
//                     model.position.x = -center.x;
//                     model.position.y = -center.y;
//                     model.position.z = -center.z;
//
//                     // Scale model so that its largest dimension is 2
//                     const maxDim = Math.max(size.x, size.y, size.z);
//                     if (maxDim > 0) {
//                         const scale = 2 / maxDim;
//                         model.scale.set(scale, scale, scale);
//                     }
//                 } else {
//                     console.warn("Model has zero size bounding box!");
//                 }
//
//                 scene.add(model);
//                 setLoading(false);
//
//                 // Set camera to properly view the model
//                 const modelCenter = new THREE.Vector3();
//                 box.getCenter(modelCenter);
//                 controls.target.copy(modelCenter);
//                 controls.update();
//             },
//             (xhr) => {
//                 const percent = ((xhr.loaded / xhr.total) * 100).toFixed(2);
//                 console.log(`Loading model: ${percent}%`);
//             },
//             (error) => {
//                 console.error('Error loading model:', error);
//                 setError('Failed to load 3D model: ' + error.message);
//                 setLoading(false);
//             }
//         );
//
//         // Animation loop
//         const animate = () => {
//             requestAnimationFrame(animate);
//             controls.update();
//             renderer.render(scene, camera);
//         };
//         animate();
//
//         // Handle window resize
//         const handleResize = () => {
//             const newWidth = mountRef.current.clientWidth;
//             const newHeight = mountRef.current.clientHeight;
//
//             camera.aspect = newWidth / newHeight;
//             camera.updateProjectionMatrix();
//
//             renderer.setSize(newWidth, newHeight);
//         };
//
//         window.addEventListener('resize', handleResize);
//
//         // Cleanup on unmount
//         return () => {
//             window.removeEventListener('resize', handleResize);
//             if (mountRef.current && mountRef.current.contains(renderer.domElement)) {
//                 mountRef.current.removeChild(renderer.domElement);
//             }
//             scene.traverse((object) => {
//                 if (object.geometry) object.geometry.dispose();
//                 if (object.material) {
//                     if (Array.isArray(object.material)) {
//                         object.material.forEach((material) => {
//                             if (material.map) material.map.dispose();
//                             material.dispose();
//                         });
//                     } else {
//                         if (object.material.map) object.material.map.dispose();
//                         object.material.dispose();
//                     }
//                 }
//             });
//             renderer.dispose();
//         };
//     }, []);
//
//     return (
//         <div style={{position: 'relative'}}>
//             <div
//                 style={{width: '100%', height: '600px', border: '1px solid #ccc'}}
//                 ref={mountRef}
//             />
//             {loading && (
//                 <div style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     backgroundColor: 'rgba(255,255,255,0.7)',
//                     padding: '10px',
//                     borderRadius: '5px'
//                 }}>
//                     Loading 3D model...
//                 </div>
//             )}
//             {error && (
//                 <div style={{color: 'red', margin: '10px 0'}}>
//                     {error}
//                 </div>
//             )}
//             {!loading && !error && (
//                 <div style={{
//                     padding: '10px',
//                     backgroundColor: '#f0f0f0',
//                     margin: '10px 0',
//                     borderRadius: '5px'
//                 }}>
//                     <p>
//                         Your model contains LineSegments (wireframe) rather than solid meshes.
//                         I've enhanced the wireframe visibility with bright cyan lines against a dark background.
//                     </p>
//                 </div>
//             )}
//             {modelInfo && (
//                 <div style={{
//                     margin: '10px 0',
//                     fontSize: '12px',
//                     fontFamily: 'monospace',
//                     whiteSpace: 'pre-wrap'
//                 }}>
//                     <details>
//                         <summary>Model Structure Debug Info (click to expand)</summary>
//                         {modelInfo}
//                     </details>
//                 </div>
//             )}
//         </div>
//     );
// };
//
// export default ThreeDModels;


import React, {useEffect, useRef, useState} from 'react';
import * as THREE from 'three';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';

const ThreeDModels = () => {
    const mountRef = useRef(null);
    const modelRef = useRef(null);
    const originalDimensionsRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modelInfo, setModelInfo] = useState("");

    // Dimensions for the UI inputs
    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 0,
        depth: 0,
    });

    useEffect(() => {
        // Set up scene, camera, and renderer
        const width = mountRef.current.clientWidth;
        const height = mountRef.current.clientHeight;

        const scene = new THREE.Scene();
        // Changed background color to white
        scene.background = new THREE.Color(0xffffff);

        const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
        camera.position.set(0, 2, 5);

        const renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setSize(width, height);
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        mountRef.current.appendChild(renderer.domElement);

        // Add orbit controls
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;
        controls.dampingFactor = 0.25;

        // Lighting
        const ambientLight = new THREE.AmbientLight(0xffffff, 1.0);
        scene.add(ambientLight);

        const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5);
        directionalLight.position.set(5, 10, 7);
        scene.add(directionalLight);

        // Removed grid helper

        // Debug function to print object hierarchy
        const debugObject = (obj, indent = 0) => {
            const spaces = ' '.repeat(indent);
            let info = `${spaces}${obj.type}: ${obj.name || 'unnamed'}\n`;
            if (obj.children && obj.children.length > 0) {
                obj.children.forEach(child => {
                    info += debugObject(child, indent + 2);
                });
            }
            return info;
        };

        // Load the model
        const loader = new GLTFLoader();
        console.log('Attempting to load model...');
        loader.load(
            '/models/BC_1D_R_1003.glb',
            (gltf) => {
                console.log('Model loaded successfully!');
                const model = gltf.scene;

                // Debug model structure
                const modelStructure = debugObject(model);
                setModelInfo(modelStructure);

                // Count meshes and line segments
                let meshCount = 0;
                let lineCount = 0;
                model.traverse((node) => {
                    if (node.isMesh) {
                        meshCount++;
                    }
                    if (node.isLineSegments) {
                        lineCount++;
                        console.log(`Found LineSegments: ${node.name}`);
                        if (node.material) {
                            node.material = new THREE.LineBasicMaterial({
                                color: 0x00ffff,
                                linewidth: 2
                            });
                        }
                    }
                });
                console.log(`Model contains ${meshCount} meshes and ${lineCount} line segments.`);

                // Removed door object logic for applying textures

                // Center and uniformly scale the model so that its largest dimension is ~2
                const box = new THREE.Box3().setFromObject(model.getObjectByName("Geometry"));
                const center = box.getCenter(new THREE.Vector3());
                const size = box.getSize(new THREE.Vector3());

                if (size.length() > 0) {
                    model.position.set(-center.x, -center.y, -center.z);
                    const maxDim = Math.max(size.x, size.y, size.z);
                    if (maxDim > 0) {
                        const uniformScale = 2 / maxDim;
                        model.scale.set(uniformScale, uniformScale, uniformScale);
                    }
                } else {
                    console.warn("Model has zero size bounding box!");
                }

                // After initial scaling, re‐measure bounding box for the final "original" dims
                const updatedBox = new THREE.Box3().setFromObject(model.getObjectByName("Geometry"));
                console.log(model)

                const updatedSize = updatedBox.getSize(new THREE.Vector3());

                console.log('size: ', size);
                console.log('updatedSize: ', updatedBox);

                originalDimensionsRef.current = {
                    width: (updatedSize.x * 1000) / 25.4,
                    height: updatedSize.y * 1000 / 25.4,
                    depth: updatedSize.z * 1000 / 25.4
                };

                // Initialize UI dimension state to the final bounding box size
                setDimensions({
                    width: updatedSize.x * 1000 / 25.4,
                    height: updatedSize.y * 1000 / 25.4,
                    depth: updatedSize.z * 1000 / 25.4
                });

                scene.add(model);
                modelRef.current = model;

                // Set camera orbit target
                const modelCenter = new THREE.Vector3();
                updatedBox.getCenter(modelCenter);
                controls.target.copy(modelCenter);
                controls.update();

                setLoading(false);
            },
            (xhr) => {
                const percent = ((xhr.loaded / xhr.total) * 100).toFixed(2);
                console.log(`Loading model: ${percent}%`);
            },
            (error) => {
                console.error('Error loading model:', error);
                setError('Failed to load 3D model: ' + error.message);
                setLoading(false);
            }
        );

        // Animation loop
        const animate = () => {
            requestAnimationFrame(animate);
            controls.update();
            renderer.render(scene, camera);
        };
        animate();

        // Handle window resize
        const handleResize = () => {
            const newWidth = mountRef.current.clientWidth;
            const newHeight = mountRef.current.clientHeight;
            camera.aspect = newWidth / newHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(newWidth, newHeight);
        };
        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (mountRef.current && mountRef.current.contains(renderer.domElement)) {
                mountRef.current.removeChild(renderer.domElement);
            }
            scene.traverse((object) => {
                if (object.geometry) object.geometry.dispose();
                if (object.material) {
                    if (Array.isArray(object.material)) {
                        object.material.forEach((material) => {
                            if (material.map) material.map.dispose();
                            material.dispose();
                        });
                    } else {
                        if (object.material.map) object.material.map.dispose();
                        object.material.dispose();
                    }
                }
            });
            renderer.dispose();
        };
    }, []);

    /**
     * Whenever the user changes dimensions in the UI, recalculate scale
     * based on the ratio of the new dimension to the original dimension.
     * Then, update any textures so they don't become distorted.
     */
    useEffect(() => {
        if (!modelRef.current || !originalDimensionsRef.current) return;

        const original = originalDimensionsRef.current;
        // Prevent division by zero
        if (!original.width || !original.height || !original.depth) return;

        const scaleX = dimensions.width / original.width;
        const scaleY = dimensions.height / original.height;
        const scaleZ = dimensions.depth / original.depth;

        console.log('scaleX: ', scaleX)

        modelRef.current.scale.set(scaleX, scaleY, scaleZ);

        // Update texture repeats so the texture scale remains visually consistent
        modelRef.current.traverse((child) => {
            if (child.isMesh && child.material && child.material.map) {
                const texture = child.material.map;
                // If the texture isn't fully loaded yet, skip
                if (!texture.image) return;

                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                // Use stored original repeat values (or fallback to the current ones)
                const originalRepeat = texture.userData.originalRepeat
                    ? texture.userData.originalRepeat.clone()
                    : texture.repeat.clone();

                // Adjust the repeat inversely to the model's scale
                texture.repeat.set(
                    originalRepeat.x / scaleX,
                    originalRepeat.y / scaleY
                );

                // Mark texture for update
                texture.needsUpdate = true;
            }
        });
    }, [dimensions]);

    // Handle dimension changes from the UI
    const handleDimensionChange = (e) => {
        const {name, value} = e.target;
        setDimensions((prev) => ({
            ...prev,
            [name]: parseFloat(value) || 0
        }));
    };

    return (
        <div style={{position: 'relative'}}>
            <div
                style={{width: '100%', height: '600px', border: '1px solid #ccc'}}
                ref={mountRef}
            />
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        padding: '10px',
                        borderRadius: '5px'
                    }}
                >
                    Loading 3D model...
                </div>
            )}
            {error && (
                <div style={{color: 'red', margin: '10px 0'}}>
                    {error}
                </div>
            )}

            {/* Only show the dimension controls after the model is loaded without error */}
            {!loading && !error && (
                <>
                    <div
                        style={{
                            padding: '10px',
                            backgroundColor: '#f0f0f0',
                            margin: '10px 0',
                            borderRadius: '5px'
                        }}
                    >
                        <p>
                            Your model contains LineSegments (wireframe) rather than solid meshes.
                            I've enhanced the wireframe visibility with bright cyan lines against a dark background.
                        </p>
                    </div>

                    <div
                        style={{
                            padding: '10px',
                            backgroundColor: '#e0e0e0',
                            margin: '10px 0',
                            borderRadius: '5px'
                        }}
                    >
                        <h3>Adjust Model Dimensions</h3>
                        <label>
                            Width:&nbsp;
                            <input
                                type="number"
                                name="width"
                                value={dimensions.width}
                                step="0.1"
                                onChange={handleDimensionChange}
                            />
                        </label>
                        <br/>
                        <label>
                            Height:&nbsp;
                            <input
                                type="number"
                                name="height"
                                value={dimensions.height}
                                step="0.1"
                                onChange={handleDimensionChange}
                            />
                        </label>
                        <br/>
                        <label>
                            Depth:&nbsp;
                            <input
                                type="number"
                                name="depth"
                                value={dimensions.depth}
                                step="0.1"
                                onChange={handleDimensionChange}
                            />
                        </label>
                    </div>
                </>
            )}

            {modelInfo && (
                <div
                    style={{
                        margin: '10px 0',
                        fontSize: '12px',
                        fontFamily: 'monospace',
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    <details>
                        <summary>Model Structure Debug Info (click to expand)</summary>
                        {modelInfo}
                    </details>
                </div>
            )}
        </div>
    );
};

export default ThreeDModels;






